(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sbl-homepage-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-sbl-spaces]').forEach((root) => {
      if (root.dataset.sblSpacesReady === 'true') return;
      root.dataset.sblSpacesReady = 'true';
      const viewer = root.querySelector('[data-sbl-viewer]');
      const image = root.querySelector('[data-sbl-viewer-image]');
      const caption = root.querySelector('[data-sbl-viewer-caption]');
      const close = root.querySelector('[data-sbl-viewer-close]');
      if (!viewer || !image || typeof viewer.showModal !== 'function') return;
      root.querySelectorAll('[data-sbl-space]').forEach((button) => {
        button.addEventListener('click', () => {
          const photo = button.querySelector('img');
          if (!photo) return;
          image.src = photo.currentSrc || photo.src;
          image.alt = button.dataset.caption || photo.alt;
          image.width = photo.naturalWidth || photo.width;
          image.height = photo.naturalHeight || photo.height;
          if (caption) caption.textContent = button.dataset.caption || '';
          viewer.showModal();
        });
      });
      if (close) close.addEventListener('click', () => viewer.close());
      viewer.addEventListener('click', (event) => {
        if (event.target === viewer) viewer.close();
      });
    });
  })();

  (() => {
    document.querySelectorAll('[data-sbl-ind]').forEach((section) => {
      if (section.dataset.sblIndReady === 'true') return;
      section.dataset.sblIndReady = 'true';
      const input = section.querySelector('[data-sbl-ind-filter]');
      const empty = section.querySelector('[data-sbl-ind-empty]');
      const cards = Array.from(section.querySelectorAll('[data-sbl-ind-card]'));
      if (!input) return;
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
          const hit = query === '' || card.dataset.keywords.includes(query);
          card.hidden = !hit;
          if (hit) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
      });
    });
  })();

  (() => {
    const roots = document.querySelectorAll('[data-sbl-home]');
    roots.forEach((root) => {
      if (root.dataset.sblReady === 'true') return;
      root.dataset.sblReady = 'true';
      const rotator = root.querySelector('[data-sbl-rotator-label]');
      const toggle = root.querySelector('[data-sbl-rotator]');
      const menu = root.querySelector('[data-sbl-menu]');
      const cardWord = root.querySelector('[data-sbl-card-word]');
      const links = Array.from(root.querySelectorAll('[data-sbl-slide-link]'));
      const slides = Array.from(root.querySelectorAll('[data-sbl-slide]'));
      const card = root.querySelector('.sbl-home__designer-card');
      if (!rotator || links.length === 0) return;

      let index = 0;
      let paused = false;
      let menuOpen = false;
      const setMenu = (open) => {
        menuOpen = open;
        paused = open;
        if (!menu || !toggle) return;
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      const show = (next) => {
        index = next;
        const word = links[index].textContent.trim();
        rotator.textContent = word;
        if (cardWord) cardWord.textContent = word;
        links.forEach((link, i) => link.setAttribute('aria-current', i === index ? 'true' : 'false'));
        slides.forEach((slide) => {
          slide.dataset.active = String(Number(slide.dataset.sblSlide) === index);
        });
      };
      show(0);

      if (toggle && menu) {
        toggle.addEventListener('click', () => setMenu(!menuOpen));
        const close = root.querySelector('[data-sbl-menu-close]');
        if (close) close.addEventListener('click', () => setMenu(false));
        document.addEventListener('click', (event) => {
          if (menuOpen && !root.querySelector('.sbl-home__picker').contains(event.target)) setMenu(false);
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && menuOpen) setMenu(false);
        });
        menu.addEventListener('mouseenter', () => { paused = true; });
        menu.addEventListener('mouseleave', () => { if (!menuOpen) paused = false; });
      }

      links.forEach((link, i) => {
        link.addEventListener('mouseenter', () => { paused = true; show(i); });
        link.addEventListener('focus', () => { paused = true; show(i); });
        link.addEventListener('mouseleave', () => { if (!menuOpen) paused = false; });
        link.addEventListener('blur', () => { if (!menuOpen) paused = false; });
      });
      if (card) {
        card.addEventListener('mouseenter', () => { paused = true; });
        card.addEventListener('mouseleave', () => { if (!menuOpen) paused = false; });
      }

      if (links.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.setInterval(() => {
        if (!paused) show((index + 1) % links.length);
      }, 2800);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbl-industries"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-sbl-industries]');
    if (!root || root.dataset.sblReady === 'true') return;
    root.dataset.sblReady = 'true';
    root.classList.add('is-enhanced');
    const links = Array.from(root.querySelectorAll('[data-sbl-industry]'));
    const panels = Array.from(root.querySelectorAll('[data-sbl-panel]'));
    const showAll = root.querySelector('[data-sbl-show-all]');
    const aliases = { universities: 'schools', warehouses: 'offices', government: 'offices' };
    const resolve = (id) => aliases[id] || id;
    const show = (id, scroll) => {
      id = resolve(id);
      const match = Boolean(id) && panels.some((panel) => panel.dataset.sblPanel === id);
      root.classList.toggle('has-selection', match);
      panels.forEach((panel) => panel.classList.toggle('is-active', match && panel.dataset.sblPanel === id));
      links.forEach((link) => link.classList.toggle('is-current', match && link.dataset.sblIndustry === id));
      if (scroll && match) {
        const panel = root.querySelector('[data-sbl-panel="' + id + '"]');
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    const jumpLinks = Array.from(root.querySelectorAll('[data-sbl-industry], [data-sbl-industry-link]'));
    jumpLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const id = link.dataset.sblIndustry || link.dataset.sblIndustryLink;
        history.replaceState(null, '', '#' + id);
        show(id, true);
      });
    });
    if (showAll) {
      showAll.addEventListener('click', () => {
        history.replaceState(null, '', window.location.pathname + window.location.search);
        show('', false);
        root.querySelector('.sbl-ind__picker').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    show((window.location.hash || '').replace('#', ''), false);
    window.addEventListener('hashchange', () => show((window.location.hash || '').replace('#', ''), false));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbl-site-header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-sbl-header]');
    if (!header || header.dataset.sblNavReady === 'true') return;
    header.dataset.sblNavReady = 'true';
    const drops = Array.from(header.querySelectorAll('[data-sbl-drop]'));

    drops.forEach((drop) => {
      const summary = drop.querySelector('summary');
      const viewAll = drop.dataset.sblViewAll;
      if (summary && viewAll) {
        summary.addEventListener('click', (event) => {
          if (!drop.open) return;
          event.preventDefault();
          window.location.assign(viewAll);
        });
      }
      drop.addEventListener('toggle', () => {
        if (!drop.open) return;
        drops.forEach((other) => {
          if (other !== drop) other.open = false;
        });
      });
    });

    const closeOutside = (event) => {
      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      const target = event.target;
      drops.forEach((drop) => {
        if (!drop.open) return;
        const inside = path.length ? path.includes(drop) : target instanceof Node && drop.contains(target);
        if (!inside) drop.open = false;
      });
    };
    document.addEventListener('click', closeOutside, true);
    window.addEventListener('blur', () => {
      drops.forEach((drop) => { drop.open = false; });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      drops.forEach((drop) => { drop.open = false; });
    });

    header.querySelectorAll('[data-sbl-mega]').forEach((panel) => {
      const input = panel.querySelector('[data-sbl-mega-filter]');
      const empty = panel.querySelector('[data-sbl-empty]');
      if (!input) return;
      const apply = () => {
        const query = input.value.trim().toLowerCase();
        panel.querySelectorAll('[data-sbl-group]').forEach((group) => {
          const title = (group.dataset.sblGroup || '').toLowerCase();
          const titleHit = query !== '' && title.includes(query);
          let any = titleHit;
          group.querySelectorAll('[data-sbl-item]').forEach((link) => {
            const hit = query === '' || titleHit || link.textContent.toLowerCase().includes(query);
            link.hidden = !hit;
            if (hit) any = true;
          });
          group.hidden = query !== '' && !any;
        });
        panel.querySelectorAll('[data-sbl-style]').forEach((link) => {
          link.hidden = query !== '' && !link.textContent.toLowerCase().includes(query);
        });
        if (!empty) return;
        const groups = Array.from(panel.querySelectorAll('[data-sbl-group]'));
        const styles = Array.from(panel.querySelectorAll('[data-sbl-style]'));
        const visibleGroup = groups.some((group) => !group.hidden);
        const visibleStyle = styles.length === 0 || styles.some((link) => !link.hidden);
        empty.hidden = !(query && !visibleGroup && !visibleStyle);
      };
      input.addEventListener('input', apply);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
